import { Component, OnInit, Inject } from '@angular/core';
import { FichaMedica } from '../../../../models/fichaMedica';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FichaMedicaService } from '../../../../services/ficha-medica.service';
import { AdjuntosService } from '../../../../services/adjuntos.service';
import { ErroresService } from '../../../../core/services/errores.service';
import { MyValidations } from '../../../../utils/my-validations';
import { DomSanitizer } from '@angular/platform-browser';
import { UnidadesTiempoService } from '../../../../services/unidades-tiempo.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-ficha-medica-editar-dialog',
  templateUrl: './ficha-medica-editar-dialog.component.html',
  styleUrls: ['./ficha-medica-editar-dialog.component.css']
})
export class FichaMedicaEditarDialogComponent implements OnInit {

  MensajeError: string = '';
  fichaInvalida: boolean;
  guardando: boolean;
  id: number = 0;
  DatosValidos: boolean;
  EsEdicion: boolean = false;
  registerForm: FormGroup;
  personalList: any;
  rubrosList: any;
  claseAusentismoList: any;
  personalId: number = 0;
  clase: number = 1;
  submitted = false;
  porHoras: boolean = false;
  selectedImage: any;
  // selectedImage: string | ArrayBuffer | null = null;
  selectedFile : File = null;
  permisoEdicion: boolean = false;
  labelCantidad: string = "Cantidad Días"
  cambioAusentismo: boolean = false;

  constructor(public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, 
                            private fichaService: FichaMedicaService, 
                            private dialog: MatDialog, 
                            private fb: FormBuilder, 
                            private sanitizer: DomSanitizer,
                            private unidadesTiempoService: UnidadesTiempoService,
                            private erroresService: ErroresService,
                            private adjuntosSrv: AdjuntosService,
                            private momentService: MomentSetService)
  {  
  }

  ngOnInit(): void
  {
    this.configurarValidadores();
    
    this.personalList = this.data.personalList;
    this.rubrosList = this.data.rubrosList;
    this.claseAusentismoList = this.data.claseAusentismoList;

    this.registerForm.patchValue(this.data.param);
    if (this.data.param.id != 0)
    {
      this.registerForm.get('desde').patchValue(new Date(this.registerForm.value.desde));
      this.registerForm.get('hasta').patchValue(new Date(this.registerForm.value.hasta));
      
      this.personalId = this.data.param.personal;
      
      this.EsEdicion = true;
      this.id = this.data.param.id;
      this.loadImage(this.data.param);
      this.onChangeRubro(this.data.param.rubro);
    }

    this.permisoEdicion = this.data.permisoEdicion;
    if (!this.permisoEdicion) this.deshabilitarForm();
  }

  configurarValidadores(): void
  {
    this.registerForm = this.fb.group({
      personal: ['', Validators.required],
      rubro: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      horaDesde: [''],
      horaHasta: [''],
      cantidad: ['', Validators.required],
      certificado: [''],
      diagnostico: ['']
    });
  }

  get registerFormControl()
  {
    return this.registerForm.controls;
  }

  onSubmit(): void
  {
    this.submitted = true;
    if (this.registerForm.valid)
    {
      this.guardando = true;

      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let entidad: FichaMedica = {
        id: this.id,
        personal: this.registerForm.value.personal,
        rubro: this.registerForm.value.rubro,
        desde: this.momentService.saveDateServer(this.registerForm.value.desde, false),
        hasta: this.momentService.saveDateServer(this.registerForm.value.hasta, false),
        cantidad: this.registerForm.value.cantidad,
        certificado: this.registerForm.value.certificado,
        diagnostico: this.registerForm.value.diagnostico,
        horaDesde: this.registerForm.value.horaDesde,
        horaHasta: this.registerForm.value.horaHasta
      };

      this.fichaService.save(entidad, this.cambioAusentismo).subscribe(
        data =>
        {
          setTimeout(function ()
          {
            this.guardando = false;
            dialogProcesandoRef.close();
          });

          this.dialogRef.close(data);
        },
        error =>
        {
          this.guardando = false;
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.fichaInvalida = true;

            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  cancelar(): void
  {
    this.dialogRef.close(null);
  }

  deshabilitarForm()
  {
    if (this.registerForm != undefined)
    {
      this.registerForm.disable();
    }
  }

  cambioCertificado(event)
  {
    if (event.checked == false) 
    {
      
    } else
    {
      
    }
  }

  setValidatorRequired(campo, requerido) {
    this.registerForm.controls[campo].setValidators(requerido);
    this.registerForm.controls[campo].updateValueAndValidity();
  }

  onChangeRubro(value)
  {
    this.cambioAusentismo = true;
    this.clase = 1;
    this.porHoras = false;
    if(value != null)
    {
      let index = this.rubrosList.findIndex(x => x.id == value)
      if (index != -1)
      {
        if (this.rubrosList[index].claseAusentismoNavigation != null)
        {
          let index2 = this.claseAusentismoList.findIndex(x => x.id == this.rubrosList[index].claseAusentismoNavigation.id)
          if (index2 != -1)
          {
            this.clase = this.claseAusentismoList[index2].unidadTiempo;
          }
        }
      }
    }
    this.habilitarSegunUnidad(this.clase);
    this.calculoCantidad();
  }

  habilitarSegunUnidad(clase)
  {
    this.labelCantidad = "Cantidad Días"
    this.porHoras = false;
    this.setValidatorRequired('horaDesde', null);
    this.setValidatorRequired('horaHasta', null);
    if (clase == 1 || clase == 2 || clase == 3)
    {
      if (clase == 3) 
      {
        this.labelCantidad = "Cantidad Horas"
        this.porHoras = true;
        this.setValidatorRequired('horaDesde', Validators.required);
        this.setValidatorRequired('horaHasta', Validators.required);
      }
    }
  }

  onChangeFechas()
  {
    this.cambioAusentismo = true;
    this.calculoCantidad();
  }

  onChangeHoras()
  {
    this.cambioAusentismo = true;
    this.calculoCantidad();
  }

  onChangePersonal(event) 
  {
    this.cambioAusentismo = true;
    this.personalId = 0

    if (event.value)
    {
      this.personalId = Number(event.value);
      this.calculoCantidad();
    }
  }

  calculoCantidad()
  {
    let cant = 0;
    let desde = this.registerForm.get("desde").value.toDateString();
    let hasta = this.registerForm.get("hasta").value.toDateString();
    let clase = this.clase;
    if (this.personalId == 0) clase = 1;

    if (clase == 1 || clase == 2 || clase == 3)
    {
      if (clase == 3)
      {
        let horaDesde = this.registerForm.get("horaDesde").value;
        let horaHasta = this.registerForm.get("horaHasta").value;   
        let tiempoD = horaDesde.substring(0,5) + ":00";
        let tiempoH = horaHasta.substring(0,5) + ":00";
        
        desde = desde + " " + tiempoD;
        hasta = hasta + " " + tiempoH;
      }

      this.unidadesTiempoService.calcularTiempoByUnidad(clase, desde, hasta, this.personalId).subscribe(
        data =>
        {
          cant = data;
          this.registerForm.controls['cantidad'].setValue(cant);
        }
      );
    } 
  }

  onFileSelected(event){
    this.selectedFile = <File>event.target.files[0];
    if(this.selectedFile != null){
      var body = new FormData();
      body.append('image', this.selectedFile, this.id.toString());
          
      var reader = new FileReader();
      reader.onload = (event: any) => {
          this.selectedImage = event.target.result;
      }
      reader.readAsDataURL(this.selectedFile);

      this.fichaService.UpdateProfileAdjunto(body, 'FichaMedica').subscribe(
        data => {
          console.log(data);
        },
        error => {
          console.log(error);
      });
    }
  }

  loadImage(ficha)
  {
    this.adjuntosSrv.getByTabla('FichaMedica', ficha.id).subscribe(
      data => {
        if (data === undefined || data == null) 
        {
          this.selectedImage = '';
        } 
        else 
        {
          if (data.foto != null ) {
            let objectURL = 'data:image/png;base64,' + data.foto;
            this.selectedImage = this.sanitizer.bypassSecurityTrustUrl(objectURL);
          } else {
            this.selectedImage = '';
          }  
        }
        console.log(data);
      },
      error => {          
        console.log(error);
      }
    );
  }
  
}
